const QueryString = require('../lib/QueryString').default;
var PageNews = {
  data(){
    return{
      enablePager: true,
      qs: QueryString.parse(),
      pageIndex: QueryString.parse().pg || 1,
      showLength: 10,
      searchQueryObj: {},
      emptyMessage: '記事がありません',
      pager: [],
      datasource: []
    }
  },
  computed:{
    pageResult: function () {
      var self = this
      var index = self.showLength * (self.pageIndex - 1)
      var length = self.showLength
      var __result = [];
      for (var i = index; i < index + length && i < self.datasource.length; i++) {
        __result.push(self.datasource[i])
      }
      return __result;
    }
  },
  created() {
    if (QueryString.parse().pagerDebug) {
      for (var i=0;i<4;i++) {
        this.informations = this.informations.concat(this.informations)
      }
    }
    this.datasource = this.informations
  },
  mounted(){
    if (this.enablePager) this.pager = this.createPagerHTML()
  },
  methods: {
    updateHistory: function () {
        var self = this;
        // ブラウザバック対応
        if (history.replaceState) {
          var historyQuery = QueryString.stringify(self.searchQueryObj);
          history.replaceState(null, null, location.pathname + (historyQuery ? "?" + historyQuery : ""))
        }
      },
      goTo: function (pageIndex) {
        var self = this;
        self.searchQueryObj = QueryString.parse()
        if (pageIndex > 0) self.pageIndex = pageIndex;
        if (pageIndex > 1) {
          self.searchQueryObj.pg = pageIndex;
        } else {
          delete self.searchQueryObj.pg
        } // ブラウザバック対応
        self.updateHistory();
        self.pager = this.createPagerHTML()
      },
      scrollToTop: function () {
        window.scrollTo(0, 0)
      },
      createPagerHTML: function () {
        var self = this

        var ret = []

        var html = ''
        if (self.datasource.length <= self.showLength) {

        } else {
          var pageCount = Math.ceil(self.datasource.length / self.showLength)

          if (self.pageIndex > 1) {
            ret.push({
              className: 'co-pagination__prev co-icon--arrow before',
              // text: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.95 54.92"><g id="レイヤー_2" data-name="レイヤー 2"><g id="レイヤー_1-2" data-name="レイヤー 1"><rect x="-2.53" y="12.47" width="39" height="9.01" transform="translate(16.97 -7.03) rotate(45)"/><rect x="-2.03" y="34.2" width="38.09" height="8.5" transform="translate(56.22 53.61) rotate(135)"/></g></g></svg>',
              onclick: function () {
                self.goTo(self.pageIndex - 1)
                self.scrollToTop()
              }
            })
          }

          if (pageCount <= 4) {
            for (var i = 1; i <= pageCount; i++) {
              ret.push({
                className: 'co-pagination__btn' + (self.pageIndex == i ? ' cu' : ''),
                text: i,
                onclick: (function (i) {
                  return function () {
                    self.goTo(i)
                    self.scrollToTop()
                  }
                })(i)
              })
            }
          } else if (self.pageIndex <= pageCount - 3) {
            var start = Math.max(self.pageIndex - 1, 1)
            var end = start + 2;
            for (var i = start; i <= end; i++) {
              ret.push({
                className: 'co-pagination__btn' + (self.pageIndex == i ? ' cu' : ''),
                text: i,
                onclick: (function (i) {
                  return function () {
                    self.goTo(i)
                    self.scrollToTop()
                  }
                })(i)
              })
            }
            ret.push({
              className: '',
              text: '…',
              onclick: (function (i) {
                return function () {}
              })(i)
            })
            ret.push({
              className: 'co-pagination__btn',
              text: pageCount,
              onclick: (function (i) {
                return function () {
                  self.goTo(pageCount)
                  self.scrollToTop()
                }
              })(pageCount)
            })
          } else {
            ret.push({
              className: 'co-pagination__btn',
              text: 1,
              onclick: (function (i) {
                return function () {
                  self.goTo(i)
                  self.scrollToTop()
                }
              })(1)
            })
            ret.push({
              className: '',
              text: '…',
              onclick: (function (i) {
                return function () {}
              })(i)
            })
            var end = Math.min(self.pageIndex + 1, pageCount)
            var start = end - 2;
            for (var i = start; i <= end; i++) {
              ret.push({
                className: 'co-pagination__btn' + (self.pageIndex == i ? ' cu' : ''),
                text: i,
                onclick: (function (i) {
                  return function () {
                    self.goTo(i)
                    self.scrollToTop()
                  }
                })(i)
              })
            }
          }

          if (self.pageIndex < pageCount) {
            ret.push({
              className: 'co-pagination__next co-icon--arrow after',
              // text: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.95 54.92"><g id="レイヤー_2" data-name="レイヤー 2"><g id="レイヤー_1-2" data-name="レイヤー 1"><rect x="-2.53" y="12.47" width="39" height="9.01" transform="translate(16.97 -7.03) rotate(45)"/><rect x="-2.03" y="34.2" width="38.09" height="8.5" transform="translate(56.22 53.61) rotate(135)"/></g></g></svg>',
              onclick: function () {
                self.goTo(self.pageIndex + 1)
                self.scrollToTop()
              }
            })
          }
        }

        return ret
      }
  }
}

module.exports = PageNews